import { Form } from 'antd';
import React from 'react';

import { IFieldBase } from '../interfaces';
import { ItemType } from '../types';
import InputCount from './InputCount';

export interface IFieldDuration<T> extends IFieldBase {
    required?: boolean;
    name?: keyof T;
}

const FieldDuration = React.forwardRef(
    <T extends Record<string, any>>(
        { disabled, required: _, name, ...restProps }: IFieldDuration<T>,
        _ref: React.Ref<any>,
    ) => {
        return (
            <Form.Item<ItemType> label="Duration" name={name as any}>
                <InputCount disabled={disabled} {...restProps} />
            </Form.Item>
        );
    },
) as <T extends Record<string, any>>(props: IFieldDuration<T> & { ref?: React.Ref<any> }) => React.JSX.Element;

export default FieldDuration;
